import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaClipboardList } from "react-icons/fa"; // Importing React Icons

const BottomNavBar = ({ photoURL }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navBar}>
      {/* Calendar Icon */}
      <button onClick={() => navigate("/calendar")} style={styles.iconButton}>
        <FaCalendarAlt style={styles.icon} />
      </button>

      {/* Roster Icon */}
      <button onClick={() => navigate("/")} style={styles.iconButton}>
        <FaClipboardList style={styles.icon} />
      </button>

      {/* Profile Icon */}
      <button onClick={() => navigate("/profile")} style={styles.profileButton}>
        <img
          src={photoURL || "https://via.placeholder.com/150"}
          alt="Profile"
          style={styles.profileIcon}
        />
      </button>
    </div>
  );
};

const styles = {
  navBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: "60px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    backgroundColor: "#fff",
    borderTop: "1px solid #ddd",
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  icon: {
    fontSize: "24px",
    color: "#000",
  },
  profileButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  profileIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
  },
};

export default BottomNavBar;
